import { firebaseConfig } from "./FirebaseConfig";

declare const firebase: any;

export interface IFirebaseService {
  load(): Promise<any>;
}

export class FirebaseService implements IFirebaseService {
  app: any;
  database: any;
  locale: string;
  data: any;
  isDataLoaded: boolean;

  constructor(locale: string) {
    this.locale = locale;
    this.isDataLoaded = false;

    this.app = firebase.initializeApp(firebaseConfig);
    this.database = firebase.database();
  }

  load = (): Promise<any> => {
    return new Promise((resolve, reject) => {
      this.database.ref("/").on(
        "value",
        (snapshot: any) => {
          this.data = snapshot.val();
          this.isDataLoaded = true;
          resolve(this.data);
        },
        (error: any) => reject(error)
      );
    });
  };
}
